import { EmployeeRequestResponsibleForAnswersRequestableTypeEnum } from 'src/app/enums/employee-request-responsible-for-answers-requestable-type.enum';

export enum EmployeeRequestApprovalPolicyEnum {
  Anyone = 'anyone',
  OnePerProduct = 'one_per_product',
  AllResponsibles = 'all_responsibles',
}

export const EmployeeRequestApprovalPolicyByRequestableType: Record<
  EmployeeRequestResponsibleForAnswersRequestableTypeEnum,
  EmployeeRequestApprovalPolicyEnum
> = {
  [EmployeeRequestResponsibleForAnswersRequestableTypeEnum.AbsenceRequest]: EmployeeRequestApprovalPolicyEnum.Anyone,
  [EmployeeRequestResponsibleForAnswersRequestableTypeEnum.ClockRegisterReviewRequest]: EmployeeRequestApprovalPolicyEnum.Anyone,
  [EmployeeRequestResponsibleForAnswersRequestableTypeEnum.RemoteWorkWeekdayExceptionRequest]:
    EmployeeRequestApprovalPolicyEnum.OnePerProduct,
  [EmployeeRequestResponsibleForAnswersRequestableTypeEnum.WorkingExtraHoursPeriod]: EmployeeRequestApprovalPolicyEnum.OnePerProduct,
  [EmployeeRequestResponsibleForAnswersRequestableTypeEnum.DrivingRequest]: EmployeeRequestApprovalPolicyEnum.Anyone,
};

export const EmployeeRequestApprovalPolicyEnumLabels: Record<EmployeeRequestApprovalPolicyEnum, string> = {
  [EmployeeRequestApprovalPolicyEnum.Anyone]: 'Cualquier responsable',
  [EmployeeRequestApprovalPolicyEnum.OnePerProduct]: 'Uno por producto',
  [EmployeeRequestApprovalPolicyEnum.AllResponsibles]: 'Todos los responsables',
};

export const EmployeeRequestApprovalPolicyEnumDescriptions: Record<EmployeeRequestApprovalPolicyEnum, string> = {
  [EmployeeRequestApprovalPolicyEnum.Anyone]: 'Basta con que un responsable acepte la solicitud.',
  [EmployeeRequestApprovalPolicyEnum.OnePerProduct]: 'Debe aceptar al menos un responsable por cada producto del solicitante.',
  [EmployeeRequestApprovalPolicyEnum.AllResponsibles]: 'Todos los responsables deben aceptar la solicitud.',
};
